<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps<{
  value?: number;
  crossedOut?: boolean;
  hideKopecks?: boolean;
}>();

const formatConfig = computed(() => ({
  lang: 'ru-RU',
  options: {
    style: 'currency',
    currency: 'RUB',
    minimumFractionDigits: 0,
    maximumFractionDigits: props.hideKopecks ? 0 : 2,
  },
}));

const valueFormatted = computed(() => {
  const formatter = new Intl.NumberFormat(
    formatConfig.value.lang,
    formatConfig.value.options as Intl.NumberFormatOptions
  );
  return formatter.format(props.value / 100);
});
</script>

<template>
  <span
    v-if="typeof value !== 'undefined'"
    class="currency"
    :class="{ 'currency_crossed-out': crossedOut }"
  >
    {{ valueFormatted }}
  </span>
</template>

<style scoped lang="stylus">
.currency
  &_crossed-out
    text-decoration line-through
</style>
